import React, { useState } from "react";
import Input from "shared/ui/Input";
import s from "./style.module.scss";
import Button from "shared/ui/Button";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { CheckInviteApi, SendInviteApi } from "./api";
import { formatPhone } from "shared/lib/formatPhone";
import { showError } from "shared/lib/showError";
import { showSuccess } from "shared/lib/showSuccess";
import { useNavigate } from "react-router-dom";

const InviteForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const { auth_key, user_info } = useAppSelector(userSelect);

  const navigate = useNavigate();

  const [phone, setPhone] = useState("");

  const [dataSending, setDataSending] = useState(false);

  const buttonDisabled = phone.trim() === "" || dataSending || phone === "+7(";

  const handleSubmit = () => {
    setDataSending(true);

    if (auth_key && user_info) {
      CheckInviteApi({
        auth_key,
        msisdn: formatPhone(phone),
        user_id: user_info.id,
      })
        .then((res) => {
          handleSendInvite(res.message);

          window.location.replace(
            `https://wa.me/7${formatPhone(phone)}/?text=${res.message}`
          );
        })
        .catch((e) => {
          showError(e, dispatch);
          setDataSending(false);
        });
    }
  };

  const handleSendInvite = (message: string) => {
    SendInviteApi({
      auth_key: auth_key!,
      message,
      msisdn: formatPhone(phone),
      user_id: user_info?.id!,
    })
      .then((res) => {
        setPhone("");
        showSuccess(dispatch, "Отправлено", "Приглашение другу отправлено");
      })
      .catch((e) => showError(e, dispatch))
      .finally(() => setDataSending(false));
  };

  return (
    <form className={s.form}>
      <Input
        className={s.input}
        mask={"+{7}(000)000-00-00"}
        value={phone}
        setValue={setPhone}
      />

      <Button
        disabled={buttonDisabled}
        className={s.button}
        onClick={handleSubmit}
      >
        Пригласить
      </Button>
    </form>
  );
};

export default InviteForm;
